import React, { FC, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useDebouncedCallback } from "@evergis/react";

import { PanelWidthDragButton } from "./styled";
import { LEFT_PANEL_MAX_WIDTH, LEFT_PANEL_MIN_WIDTH } from "./constants";
import { resizePanelContainer } from "../../ducks/layout/layout";

interface PanelWidthDragProps {
  setIsResizing?: (value: boolean) => void;
}

export const PanelWidthDrag: FC<PanelWidthDragProps> = ({ setIsResizing }) => {
  const dispatch = useDispatch();
  const debounce = useDebouncedCallback(10);

  const onPointerDown = useCallback(() => {
    setIsResizing(true);

    function onPointerMove(pointerMoveEvent) {
      const newWidth = pointerMoveEvent.pageX;

      document.body.style.userSelect = "none";

      if (newWidth >= LEFT_PANEL_MIN_WIDTH && newWidth < LEFT_PANEL_MAX_WIDTH) {
        debounce(() => {
          dispatch(resizePanelContainer(newWidth));
        });
      }
    }

    function onPointerUp() {
      setIsResizing(false);
      document.body.style.userSelect = "initial";
      document.body.removeEventListener("pointermove", onPointerMove);
    }

    document.body.addEventListener("pointermove", onPointerMove);
    document.body.addEventListener("pointerup", onPointerUp, { once: true });
  }, [debounce, dispatch, setIsResizing]);

  return <PanelWidthDragButton onPointerDown={onPointerDown} />;
};
